<template>
  <div
    v-if="show"
    class="virtual-vist-initial-container"
  >
    <div class="virtual-visit-initial-content-container">
      <div class="virtual-visit-initial-content-title-container">
        <div class="virtual-visit-initial-content-title">
          <span class="blue-title">Deliver comfort</span>
        </div>
        <div class="virtual-visit-initial-content-title">
          right from your desk
        </div>
      </div>
      <div class="virtual-visit-initial-content-body-container">
        <div class="virtual-visit-initial-content-body">
          <b>Virtual Visits</b> from SmartAC.com lets you record a video walkthrough of a
          customer&apos;s account to review what&apos;s working & what&apos;s not.
        </div>
      </div>
      <button
        type="button"
        @click="launchVirtualVisit"
      >
        <div class="virtual-visit-initial-record-btn">
          <img
            src="@shared/assets/img/general/record-video-icon.svg"
            class="record-camera-icon"
            alt="Record Video"
          >
          <div class="record-btn-txt">
            Record your First Virtual Visit
          </div>
        </div>
      </button>
    </div>
    <div class="initial-virtual-visit-graphic-container">
      <img
        class="virtual-visit-graphic"
        src="@shared/assets/img/general/man-on-desk.svg"
        alt="Technician"
      >
      <button
        type="button"
        @click="close"
      >
        <img
          class="virtual-visit-initial-x"
          src="@shared/assets/img/general/light-blue-x.svg"
          alt="Close"
        >
      </button>
    </div>
  </div>
</template>
<script>
import customerDetailMixin from '@shared/mixins/customerDetailMixin';

export default {
  name: 'FindVirtualVisit',
  mixins: [customerDetailMixin],
  data() {
    return {
      show: true,
    };
  },
  methods: {
    close() {
      this.show = false;
    },
    launchVirtualVisit() {
      this.toggleActionModal(true, 'launch-visit');
    },
  },
};
</script>

<style lang="scss">

.virtual-vist-initial-container {
  background-color: #EFF8FF;
  border-style: solid;
  border-color: #7CAACA;
  ;
  border-width: 1px;
  border-radius: 5px;
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  margin-top: 15px;

  .virtual-visit-initial-content-container {
    display: flex;
    flex-direction: column;
    justify-content: center;
    padding: 18px 0 18px 20px;

    .virtual-visit-initial-content-title-container {
      margin-bottom: 30px;
    }

    .virtual-visit-initial-content-title {
      line-height: 1;
      font-weight: 600;
      font-size: 3.5rem;

      @media (max-width: 1400px) {
        font-size: 3rem;
      }
    }

    .blue-title {
      color: $PRIMARY;
    }

    .virtual-visit-initial-content-body-container {
      margin-bottom: 50px;

      @media (max-width: 1400px) {
        margin-bottom: 36px;
      }
    }

    .virtual-visit-initial-content-body {
      line-height: 1;
      font-size: 1rem;

      @media (max-width: 1400px) {
        font-size: 0.875rem;
      }
    }

    .virtual-visit-initial-record-btn {
      display: flex;
      flex-direction: row;
      background-color: $PRIMARY;
      width: 322px;
      padding: 10px;
      height: 46px;
      align-items: center;
      border-radius: 4px;
    }

    .record-btn-txt {
      color: $WHITE;
      font-size: 18px;
      font-weight: 400;
    }

    .record-camera-icon {
      height: 18px;
      width: 32px;
      margin-right: 5px;
    }
  }

  .initial-virtual-visit-graphic-container {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: flex-start;

    .virtual-visit-graphic {
      mix-blend-mode: multiply;
      width: 573px;
      height: 340px;
    }
  }

  .initial-virtual-visit-exit-container {
    .virtual-visit-initial-x {
      height: 24px;
      width: 24px;
    }
  }
}
</style>
